/**
 * The overlays behind the project download popup: the mobile sheet that hosts
 * the popup body, the bulk-export confirmation and the enrichment contacts
 * dialog. Rendered once at the host's root, outside any early-return branch.
 *
 * Extracted from `ProfilerProjectView` (TD-2970).
 */
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import MobileSheet from '../../common/MobileSheet';
import BulkExportConfirmModal from '../../common/BulkExportConfirmModal';
import ProjectContactsDownloadDialog from '../../enrichment/ProjectContactsDownloadDialog';
import { precheckIncludesContacts } from '../../../utils/profilerDownloadHelpers';
import { ProjectDownloadPopupBody } from './ProjectDownloadControls';
import { projectDownloadsShape } from './projectDownloadsShape';

const ProjectDownloadOverlays = observer(({ downloads, isMobile }) => {
  const { state, project, nonExcludedResultsCount, bulkExport, contactsDownload } = downloads;

  return (
    <>
      {/* Gated on the mobile layout so showModal never fires for the desktop
          dropdown, which shares `state.isOpen`. Picking an entry closes the
          sheet first, so what it opens is not left under the sheet's backdrop. */}
      <MobileSheet isOpen={isMobile && state.isOpen} onClose={state.close} title="Download">
        <ProjectDownloadPopupBody downloads={downloads} onSelect={state.close} />
      </MobileSheet>
      <BulkExportConfirmModal
        isOpen={bulkExport.pendingType !== null}
        totalCompanies={nonExcludedResultsCount}
        downloads={downloads.downloads}
        period={downloads.period}
        source="project"
        sourceId={project?.id}
        includeContacts={precheckIncludesContacts(bulkExport.pendingType)}
        prefillData={bulkExport.prefillData}
        onConfirm={bulkExport.confirm}
        onCancel={bulkExport.cancel}
      />
      <ProjectContactsDownloadDialog
        isOpen={contactsDownload.isOpen}
        onClose={contactsDownload.close}
        projectId={project?.id}
        companyCount={nonExcludedResultsCount}
      />
    </>
  );
});

ProjectDownloadOverlays.propTypes = {
  downloads: projectDownloadsShape.isRequired,
  /** Mobile layout of the host; the sheet only opens there. */
  isMobile: PropTypes.bool.isRequired
};

export default ProjectDownloadOverlays;
